import { campaigns } from './campaigns';
import { stats } from './stats';
import { webhook } from './webhook';
import { products } from './products';
import { operators } from './operators';
export const autocaller_v2 = {
  namespaced: true,
  modules: { 
    campaigns,
    stats,
    webhook,
    operators,
    products
  }
};
